import { useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';

import { Box, Button, Icon, Typography } from '@myn/mui';

const InternalServerErrorPage = () => {
  const { t } = useTranslation('@mint-admin/secured-layout');

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      gap={(theme) => theme.spacing(8)}
    >
      <Box
        display="inline-flex"
        flexDirection="column"
        justifyContent="center"
        gap={(theme) => theme.spacing(3)}
      >
        <Box
          display="inline-flex"
          gap={(theme) => theme.spacing(1)}
          alignItems={'center'}
        >
          <Icon
            component={'WarningFilled'}
            fontSize="large"
            className="fill-error-main text-error-main"
          />
          <Typography variant="h3" color={'error.main'}>
            {t('500 Internal Server Error')}
          </Typography>
        </Box>
        <Typography variant="h1" color="text.primary">
          {t('Something went wrong')}
        </Typography>
        <Typography variant="bodyShort01" color="text.primary">
          {t(
            'We are informed of your issue, we are working on it to resolve it.',
          )}
        </Typography>
        <Box display="flex" gap={2}>
          <Button
            // refresh the page
            onClick={() => {
              globalThis.location.reload();
            }}
            variant="outlined"
            size="large"
            color="primary"
          >
            {t('Reload the page')}
          </Button>

          <Button
            variant="contained"
            href="https://support.mint.ai"
            size="large"
            color="primary"
          >
            {t('Visit our Help Center')}
          </Button>
        </Box>
      </Box>
      <Illustration className="size-80" component="IllustrationError500" />
    </Box>
  );
};
export default InternalServerErrorPage;
